import { store } from 'store/store';

export enum DEPEND_CONDITION_RULES {
	NOT_APPLICABLE = 'NotApplicable',
	MATCH_REGULAR_EXPRESSION = 'MatchRegularExpression',
	EMPTY = 'Empty',
	EQUALS = 'Equals',
	NOT_EQUALS = 'NotEquals',
	CONTAINS = 'Contains',
	NOT_CONTAINS = 'NotContains',
	GREATER_THAN = 'GreaterThan',
	LESS_THAN = 'LessThan',
	GREATER_THAN_OR_EQUAL_TO = 'GreaterThanOrEqualTo',
	LESS_THAN_OR_EQUAL_TO = 'LessThanOrEqualTo',
}

// Map fields that have an empty dependency to avoid re-evaluating them multiple times.
const fieldIsEmptyResolved: Map<string, boolean> = new Map();

export const isFieldHidden = (field: FieldsContent): boolean => {
	if (field.content.contentType === 'ModalContentBlock' || field.content.contentType === 'FlowRestrictionBlock') {
		return false;
	}
	return isHidden(field?.content?.contentDependency);
};
export const isPageHidden = (page: StepBlock): boolean => {
	const isHidden_ = isHidden(page?.contentDependency);
	if (!isHidden_) {
		// check that all fields are not hidden
		const visibleFields = page?.fields?.items?.some(
			(field) =>
				!isFieldHidden(field) &&
				field.content.contentType !== 'ModalContentBlock' &&
				field.content.contentType !== 'FlowRestrictionBlock'
		);
		return !visibleFields;
	}
	return isHidden_;
};

export const meetDependency = (dependency: ContentDependency, value) => {
	return !isHidden(dependency, value);
};

const isHidden = (dependency: ContentDependency, value?) => {
	const dependsOnId = dependency?.dependsOn?.uid;
	if (dependsOnId) {
		const dependentValue = value ?? store.getState().calculatorForm[dependsOnId]?.data?.value;
		switch (dependency.dependCondition) {
			case DEPEND_CONDITION_RULES.NOT_APPLICABLE:
				return existDependency(dependentValue);
			case DEPEND_CONDITION_RULES.EQUALS:
				return equals(dependency, dependentValue);
			case DEPEND_CONDITION_RULES.EMPTY:
				return empty(dependency, dependentValue);
			case DEPEND_CONDITION_RULES.NOT_EQUALS:
				return !equals(dependency, dependentValue);
			case DEPEND_CONDITION_RULES.MATCH_REGULAR_EXPRESSION: // implement
				return false;
			case DEPEND_CONDITION_RULES.CONTAINS:
				return contains(dependency, dependentValue);
			case DEPEND_CONDITION_RULES.NOT_CONTAINS:
				return !contains(dependency, dependentValue);
			default:
				return false;
		}
	}
	return false;
};

const existDependency = (dependentValue): boolean => {
	return dependentValue === undefined || dependentValue === null;
};

const equals = (dependency: ContentDependency, dependentValue): boolean => {
	return dependency.dependValue !== dependentValue;
};

const empty = (dependency: ContentDependency, dependentValue): boolean => {
	// Check if empty rule for this field has been run before, if yes, return the resolved value
	if (fieldIsEmptyResolved.get(dependency.dependsOn.uid) !== undefined) {
		return fieldIsEmptyResolved.get(dependency.dependsOn.uid);
	}

	const trimmedValue = dependentValue?.toString()?.trim();

	switch (trimmedValue) {
		case undefined:
		case null:
		case '':
			fieldIsEmptyResolved.set(dependency.dependsOn.uid, false);
			return false;
		default:
			fieldIsEmptyResolved.set(dependency.dependsOn.uid, true);
			return true;
	}
};

const contains = (dependency: ContentDependency, dependentValue): boolean => {
	// if no dependency.dependValue, then don't hide
	if (!dependency.dependValue) return false;
	return !dependentValue?.includes(dependency.dependValue);
};
